module.exports = __webpack_public_path__ + "media/images/athletes/4176-8163889a998ec9ef785b9bc77c694d8d.png";